import { render, staticRenderFns } from "./sync-agent-from-expert-modal.vue?vue&type=template&id=3179048a"
import script from "./sync-agent-from-expert-modal.vue?vue&type=script&lang=ts"
export * from "./sync-agent-from-expert-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports